import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-regular",
  "use": "icon-regular-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-regular\">\n<circle cx=\"9\" cy=\"9\" r=\"7\" stroke=\"#323232\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.5 8.5V6H8.5V8.5H6V9.5H8.5V12H9.5V9.5H12V8.5H9.5Z\" fill=\"#323232\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol